'use client';

import { customRichTextComponent } from '@/sanity/sanityPortableText';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/shadcn/ui/accordion';
import { motion } from 'framer-motion';
import { PortableText } from 'next-sanity';
import { PortableTextBlock } from 'sanity';
import { useState } from 'react';

export default function FAQ({
  faqs,
}: {
  faqs?: {
    title?: string;
    texts?: {
      content: PortableTextBlock[];
    }[];
  }[];
}) {
  const [active, setActive] = useState<string | undefined>(undefined);

  if (!faqs || !Array.isArray(faqs)) {
    return null;
  }

  return (
    <Accordion
      className="flex flex-col relative z-[5] w-full m-auto border-b-[.125rem] border-black/[15%]"
      type="single"
      collapsible
      onValueChange={setActive}
    >
      {faqs.map((item, index) => {
        const value = `value-${index}`;
        const isActive = active === value;
        return (
          <motion.div
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            initial={{
              opacity: 0,
              y: 20,
            }}
            viewport={{
              once: true,
              amount: 0.8,
            }}
            transition={{ duration: 0.3, delay: 0.2 + index * 0.1 }}
            className="relative"
            key={index}
          >
            <AccordionItem
              key={index}
              className="duration-300 w-full transition-all z-[1] relative border-t-[.125rem] border-black/[15%]
             "
              value={value}
            >
              <AccordionTrigger className="relative group p-[4rem]" useToggleIcon={true}>
                <h3 className="text-[3rem] text-black font-nunito font-[300] duration-100 transition-all flex items-start text-left relative z-[1] max-w-[82%] lg:max-w-[90%]">
                  {item?.title}
                </h3>
              </AccordionTrigger>
              <AccordionContent className="relative p-[4rem] z-[1] flex items-start gap-[2rem] lg:gap-[3rem]">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-[5.5rem] w-full">
                  {item?.texts && Array.isArray(item.texts) && item.texts.map((text, textIndex) => (
                    <div className="flex flex-col prose-p:text-black/[72%]">
                      <PortableText
                        key={textIndex}
                        //@ts-ignore
                        value={text.content}
                        components={customRichTextComponent({
                          block: {
                            normal: ({ children }) => {
                              return (
                                <p className="text-[2rem] font-nunito font-[300] text-left leading-[160%] mb-0">
                                  {children}
                                </p>
                              );
                            },
                          },
                          marks: {
                            strong: ({ children }) => {
                              return (
                                <span className="font-[700]">{children}</span>
                              );
                            },
                          },
                        })}
                      />
                    </div>
                  ))}
                </div>
              </AccordionContent>
            </AccordionItem>
          </motion.div>
        );
      })}
    </Accordion>
  );
}
